// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Quantify.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Astonpoliz.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Quantify";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 300;
    font-style: 100%;
    color: #002d72;
}
@font-face {
    font-family: "Astonpoliz";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    font-weight: 200;
    color: #002d72;
}
:root {
    --bg-color: #a89984;
    --text-color: #3c3836;
    --hover-color: #cc241d;
    --title-color: #458588;
    --shadow-color: #504945;
    --frame-color: #d79921;
}
@media (prefers-color-scheme: dark) {
    :root {
        --bg-color: #3c3836;
        --text-color: #d5c4a1;
        --shadow-color: #665c54;
        --hover-color: #689d6d;
        --title-color: #458588;
        --frame-color: #d79921;
    }
}
/*-----------------------BASIC---------------------------------------------------------BASIC---------------------------------------------------*/
body {
    margin: 0;
    padding: 0;
    font-family: "Astonpoliz";
    background-color: var(--bg-color);
    color: var(--text-color);
    box-sizing: border-box;
}
a {
    color: var(--text-color);
    text-decoration: none;
    font-style: italic;
}
a:hover {
    color: var(--hover-color);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,4CAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,4CAAgC;IAChC,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI;QACI,mBAAmB;QACnB,qBAAqB;QACrB,uBAAuB;QACvB,sBAAsB;QACtB,sBAAsB;QACtB,sBAAsB;IAC1B;AACJ;AACA,gJAAgJ;AAChJ;IACI,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,iCAAiC;IACjC,wBAAwB;IACxB,sBAAsB;AAC1B;AACA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B","sourcesContent":["@font-face {\n    font-family: \"Quantify\";\n    src: url(\"fonts/Quantify.ttf\");\n    font-weight: 300;\n    font-style: 100%;\n    color: #002d72;\n}\n@font-face {\n    font-family: \"Astonpoliz\";\n    src: url(\"fonts/Astonpoliz.ttf\");\n    font-weight: 200;\n    color: #002d72;\n}\n:root {\n    --bg-color: #a89984;\n    --text-color: #3c3836;\n    --hover-color: #cc241d;\n    --title-color: #458588;\n    --shadow-color: #504945;\n    --frame-color: #d79921;\n}\n@media (prefers-color-scheme: dark) {\n    :root {\n        --bg-color: #3c3836;\n        --text-color: #d5c4a1;\n        --shadow-color: #665c54;\n        --hover-color: #689d6d;\n        --title-color: #458588;\n        --frame-color: #d79921;\n    }\n}\n/*-----------------------BASIC---------------------------------------------------------BASIC---------------------------------------------------*/\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: \"Astonpoliz\";\n    background-color: var(--bg-color);\n    color: var(--text-color);\n    box-sizing: border-box;\n}\na {\n    color: var(--text-color);\n    text-decoration: none;\n    font-style: italic;\n}\na:hover {\n    color: var(--hover-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
